module.exports = __webpack_public_path__ + "img/del.a3441da5.png";